import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../client';

export type ChangePasswordInput = {
  oldPassword: string;
  newPassword: string;
};

export type ChangePasswordResponse = {
  status: string;
  error: string;
};

export const changePasswordRequest = async (data: ChangePasswordInput) =>
  restClient.request<ChangePasswordResponse>(
    '/auth/change_password',
    {
      method: 'POST',
      data: snakecaseKeys(data)
    }
  );